import { Typography } from "@mui/material";
import { Button } from "components/LoadingButton";
import { Modal } from "components/Modal";

export const ConfirmDeleteModal = ({
  open,
  onClose,
  onConfirm,
  title = "تأیید حذف",
  message,
  loading = false,
}) => (
  <Modal
    open={open}
    onClose={loading ? undefined : onClose}
    title={title}
    maxWidth="xs"
    responsive={false}
    footerEnd={
      <>
        <Button
          variant="contained"
          color="error"
          size="xsmall"
          loading={loading}
          loadingText="در حال حذف..."
          onClick={onConfirm}
        >
          بله، حذف شود
        </Button>
        <Button
          variant="contained"
          color="inherit"
          size="xsmall"
          disabled={loading}
          onClick={onClose}
        >
          انصراف
        </Button>
      </>
    }
  >
    <Typography sx={{ direction: "rtl", textAlign: "right", lineHeight: 2 }}>{message}</Typography>
  </Modal>
);
